import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-commissions',
  templateUrl: 'commissions.html'
})
export class CommissionsPage {
  constructor(public navCtrl: NavController, public navParams: NavParams) {}

  ionViewDidLoad() {
    console.log('ionViewDidLoad CommissionsPage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/commissions/commissions.ts